export const detectionsEn = {
    api: {
        error: {
            exportDetections: 'Error while generating the file',
            fetchDetections: 'Error while fetching reads'
        },
        success: {
            exportDetections: 'File has been successfully generated',
            fetchDetections: 'Erreur pendant la récupération des détections'
        }
    },
    actions: {},
    export: {
        allDetections: 'All reads',
        currentPage: 'Only the current page (Page {page})',
        device: 'Device'
    },
    filters: {
        bib: 'Bib',
        checkpoint: 'POI',
        startDate: 'From',
        start_at: 'From',
        end_at: 'To',
        endDate: 'To',
        device: 'Device',
        event: 'Site',
        siteId: 'Site ID',
        timerId: 'Timer ID',

        origin: 'Origin',
        destination: 'Destination',

        arrived_at_from: 'Arrived from',
        arrived_at_to: 'Arrived to',
        left_at_from: 'Left from',
        left_at_to: 'Left to'
    },
    model: {
        bib: 'Bib',
        poiId: 'POI',
        deviceId: 'Device ID',
        eventFilter: 'Site ID',
        id: 'ID',
        timerFilter: 'Timer ID',
        timestamp: 'Date'
    },
    noDetectionFound: 'No detection found',
    table: {
        bib: 'Bib',
        poiName: 'POI',
        siteName: 'Site',
        detections: 'Reads',
        deviceId: 'Device ID',
        deviceName: 'Device name',
        eventFilter: 'Site ID',
        id: 'ID',
        timerFilter: 'Timer ID',
        timestamp: 'Date',

        origin_poi: 'Origin POI',
        origin_name: 'Origin name',
        destination_name: 'Destination name',
        destination_poi: 'Destination POI',
        epc: 'EPC',
        epc_type: 'EPC type',
        start_at: 'Start at',
        end_at: 'End at',

        arrived_at_origin: 'Arrived at (origin POI)',
        arrived_at_destination: 'Arrived at (destination POI)',

        poi_id: 'ID',
        poi_name: 'POI',
        arrived_at: 'Arrived at',
        left_at: 'Left at',
        duration: 'Duration',
        status: 'Status'
    }
}
